import arrowHorizontalImg from '../components/atomic/buttons/arrows/arrow_horizontal.png';
import arrowVerticalImg from '../components/atomic/buttons/arrows/arrow_vertical.png';
import starImg from '../components/atomic/icons/star/star.png';
import ticketImg from '../components/atomic/icons/ticket/ticket.png';
import deliveriesIcon from '../components/composite/nav/nav_bar/deliveries_icon.png';
import mapIcon from '../components/composite/nav/nav_bar/map_icon.png';
import rewardsIcon from '../components/composite/nav/nav_bar/rewards_icon.png';
import hintIconSvg from './delivery_hint_icon/hint_icon.svg';
import plaqueImg from './plaque/plaque.png';
import playerLevelPlaqueImg from './player_level_screen_button/plaque.png';

export function getMapHudAssetUrls(): string[] {
  return [
    plaqueImg,
    playerLevelPlaqueImg,
    hintIconSvg,
    starImg,
    ticketImg,
    arrowHorizontalImg,
    arrowVerticalImg,
    mapIcon,
    deliveriesIcon,
    rewardsIcon,
  ];
}
